import CTA from '../CTA'
import Disclaimer from '../Disclaimer'
import RadioOptions, { RadioOptionsProps } from './RadioOptions'
import { LOCAL_STORAGE_PROVIDER } from '@/features/knowledge-bases/domain'

interface RadioOptionGroupProps extends Omit<RadioOptionsProps, 'onChange'> {
  isDisabled: boolean
  onChange: (value: string) => void
  onConfirm: () => void
  disclaimerText: string
  confirmButtonText: string
}

const RadioOptionGroup = ({
  name,
  options,
  value,
  isDisabled,
  onChange,
  onConfirm,
  disclaimerText,
  confirmButtonText = 'Guardar',
}: RadioOptionGroupProps) => {
  const showWarning = value !== LOCAL_STORAGE_PROVIDER

  return (
    <section className="radio-option-group">
      <RadioOptions
        name={name}
        options={options}
        value={value}
        onChange={onChange}
      />
      <div className="radio-option-group-action">
        <Disclaimer
          variant={showWarning ? 'warning' : 'default'}
          text={disclaimerText}
        />

        <CTA variant="system" isDisabled={isDisabled} onClick={onConfirm}>
          {confirmButtonText}
        </CTA>
      </div>
    </section>
  )
}

export default RadioOptionGroup
